import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

// Debug: Log environment variables
console.log('Pusher Config:', {
    key: process.env.REACT_APP_PUSHER_APP_KEY,
    cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
    apiUrl: process.env.REACT_APP_API_URL,
});

let echoInstance = null;

/**
 * Get or create Echo instance with fresh authentication token.
 * Recreates instance if token has changed since last creation.
 */
export function getEcho() {
    const currentToken = localStorage.getItem('token');

    // Don't create Echo instance if no token
    if (!currentToken) {
        console.warn('No token found - cannot initialize Echo');
        return null;
    }

    // Create new instance if none exists OR token has changed
    if (!echoInstance || echoInstance._token !== currentToken) {
        console.log('Creating new Echo instance with fresh token', {
            tokenPreview: currentToken.substring(0, 20) + '...',
            authEndpoint: `${process.env.REACT_APP_API_URL || 'http://localhost:8648/api'}/broadcasting/auth`
        });

        if (echoInstance) {
            // Disconnect old instance
            echoInstance.disconnect();
        }

        echoInstance = new Echo({
            broadcaster: 'pusher',
            key: process.env.REACT_APP_PUSHER_APP_KEY,
            cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
            wsHost: process.env.REACT_APP_PUSHER_HOST,
            wsPort: Number(process.env.REACT_APP_PUSHER_PORT) || 6001,
            wssPort: Number(process.env.REACT_APP_PUSHER_PORT) || 6001,
            forceTLS: process.env.REACT_APP_PUSHER_SCHEME === 'https',
            disableStats: true,
            enabledTransports: ['ws', 'wss'],
            authEndpoint: `${process.env.REACT_APP_API_URL || 'http://localhost:8648/api'}/broadcasting/auth`,
            auth: {
                headers: {
                    Authorization: `Bearer ${currentToken}`,
                    Accept: 'application/json',
                },
            },
        });

        // Store token reference for change detection
        echoInstance._token = currentToken;

        // Debug: Log connection state
        echoInstance.connector.pusher.connection.bind('connected', () => {
            console.log('✅ Pusher connected successfully');
        });

        echoInstance.connector.pusher.connection.bind('error', (err) => {
            console.error('❌ Pusher connection error:', err);
        });

        // Debug: Log authentication errors
        echoInstance.connector.pusher.connection.bind('subscription_error', (err) => {
            console.error('❌ Channel subscription error:', err);
        });
    }

    return echoInstance;
}

// For backward compatibility with existing imports
// Note: This will return null if user is not logged in
export default getEcho();

// Export function to manually reconnect with fresh token
export function reconnectEcho() {
    console.log('Forcing Echo reconnection with fresh token');
    echoInstance = null;
    return getEcho();
}

// Disconnect and destroy the Echo instance (call on logout)
export function disconnectEcho() {
    if (echoInstance) {
        echoInstance.disconnect();
        echoInstance = null;
    }
}
